<template>
  <b-row class="m-3">
    <b-col md="10" offset-md="1" lg="8" offset-lg="2">
      <h5 class="mb-1">Frequently Asked Questions</h5>
      <p class="text-muted mb-3" style="font-size:0.9rem;">
        The site better communicates union news to the growing and diverse membership. It streamlines the dissemination of vital information, ranging from political updates, event announcements and training opportunities. The registration component also ensures a secure connection between you and the UBC. Are you having trouble creating your account with Carpenters.org? Read on and find your answers here.
      </p>
      <div v-for="(item, i) in faqs" :key="i" class="mb-1">
        <b-card no-body>
          <b-card-header header-tag="div" class="p-0">
            <b-button block v-b-toggle="`faq-${i}`" variant="light" class="text-left faq-btn">
              <strong>{{ i + 1 }}.</strong> {{ item.q }}
            </b-button>
          </b-card-header>
          <b-collapse :id="`faq-${i}`">
            <b-card-body class="faq-answer">
              <b-button v-if="item.modal" variant="link" class="p-0" @click="$bvModal.show(item.modal)">
                Watch video instructions
              </b-button>
              <span v-else v-html="item.a" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <b-modal id="video-q1" title="How do I register for an account?" hide-footer size="lg">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/499357013?h=8f90f78880"
            class="embed-responsive-item"
            frameborder="0"
            referrerpolicy="strict-origin-when-cross-origin"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            allowfullscreen
          />
        </div>
      </b-modal>

      <b-modal id="video-q2" title="How do I get my username or reset my password?" hide-footer size="lg">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/499357415?h=4bd1840568"
            class="embed-responsive-item"
            frameborder="0"
            referrerpolicy="strict-origin-when-cross-origin"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            allowfullscreen
          />
        </div>
      </b-modal>

      <b-modal id="video-q3" title="How do I clear my browser cache?" hide-footer size="lg">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            title="vimeo-player"
            src="https://player.vimeo.com/video/499356461?h=7ff488b8b3"
            class="embed-responsive-item"
            frameborder="0"
            referrerpolicy="strict-origin-when-cross-origin"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            allowfullscreen
          />
        </div>
      </b-modal>

      <div class="text-right mt-3">
        <b-button size="sm" variant="primary" :to="{ name: 'login' }">Back to Login</b-button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component({
  metaInfo: {
    title: 'Member Portal - FAQ'
  }
})
export default class FAQ extends Vue {
  get memberPortalUrl() {
    return this.$store.getters.meta?.memberPortalUrl || 'https://member-portal.carpenters.org';
  }

  get faqs() {
    const contactUrl = `${this.memberPortalUrl}/app/contact`;
    return [
      {
        q: 'How do I register for an account with the Carpenters Member Portal website?',
        modal: 'video-q1'
      },
      {
        q: 'How do I get my username or reset my password?',
        modal: 'video-q2'
      },
      {
        q: 'How do I clear my browser cache to resolve issues logging into the website?',
        modal: 'video-q3'
      },
      {
        q: 'Where do I find my UBC ID number?',
        a: 'Your UBC membership identification number is found on your dues card, your work card or at your Local.'
      },
      {
        q: "What if I don't have an e-mail address?",
        a: `An e-mail address is required to create your Carpenters.org account. An e-mail is needed because it ensures a secure connection between you and the UBC. Registering with Carpenters.org is good for you \u2013 it keeps you up-to-date on all vital news, training and event announcements \u2013 and it\u2019s good for the union. We recommend you open an e-mail account with one of these free Web-based providers:
          <ul class="mt-2 mb-0">
            <li><a href="http://mail.yahoo.com/" target="_blank" rel="noopener">Yahoo Mail</a></li>
            <li><a href="http://gmail.com/" target="_blank" rel="noopener">Google Mail</a></li>
            <li><a href="http://hotmail.com/" target="_blank" rel="noopener">HotMail</a></li>
          </ul>
          <p class="mt-2 mb-0">This is an easy and quick task that can be accomplished in minutes.</p>`
      },
      {
        q: 'I did not receive the account verification email. Did I do something wrong?',
        a: `In most cases, the account verification email should arrive within a few seconds of submitting the registration form, but if you don\u2019t see the email, here are a few things you can try:
          <ul class="mt-2 mb-0">
            <li>If there is a lot of traffic, it may take as much as a couple of minutes to arrive in your Inbox. Wait a few minutes and see if it arrives.</li>
            <li>Check your spam and/or junk folders as it may have been filtered incorrectly.</li>
            <li>Try resubmitting the registration and verify the email address is correct.</li>
            <li>If you\u2019re still having trouble, please <a href="${contactUrl}">contact an administrator</a>.</li>
          </ul>`
      },
      {
        q: 'I clicked on the button in the verification email and nothing happened. Did I do something wrong?',
        a: 'Some email clients disable links for security reasons. At the bottom of the same email, you should see a full URL for just this scenario. Copy and paste this URL into the browser address bar.'
      },
      {
        q: "My new chosen password isn't being accepted by the site. What happened?",
        a: `<ol class="mt-0 mb-0">
            <li>Passwords must be at least eight characters long</li>
            <li>Must contain characters from three of these four categories:
              <ul>
                <li>Uppercase characters (A thru Z)</li>
                <li>Lowercase characters (a thru z)</li>
                <li>Base 10 digits (0 through 9)</li>
                <li>Non-alphanumeric characters: ~!@#$%^&amp;*_-+=\`|\\(){}[]:;"'&gt;&lt;,.?/</li>
              </ul>
            </li>
          </ol>`
      },
      {
        q: 'How do I update my membership information?',
        a: 'To update your membership information, log in and click Update Contact Information.'
      },
      {
        q: 'How do I access a Department of Education & Training (DET) online program?',
        a: `Your Council must first register you to participate in a DET online program. If you have been registered, go to <a href="https://ubcdet.carpenters.org" target="_blank" rel="noopener">https://ubcdet.carpenters.org</a> and enter your Carpenters.org username and password to log in.<br><br>If you have not been registered for an online program or taken a DET course at the International Training Center, please contact your Council Enroller for assistance.`
      },
      {
        q: 'How do I pay for dues?',
        a: 'To pay dues, please contact your Local Union office directly. This website does not provide an option to pay dues online.'
      },
      {
        q: 'Who do I contact for information about pension, insurance, and other benefits?',
        a: 'For questions regarding pension, insurance, and other benefits, please contact your Regional Council or Trust Fund directly.'
      },
      {
        q: 'How do I get information about training or certifications?',
        a: 'You can view training and certification information by scanning your Training Verification Card. For questions about training or certifications, please use the <a href="https://www.carpenters.org/training-center/" target="_blank" rel="noopener">Training Center directory</a> to locate a UBC Training Center in your area.'
      },
      {
        q: 'Where do I submit general requests for information or grievances?',
        a: 'General requests for information or grievances must be submitted to your Regional Council or Local Union. Please use the <a href="https://www.carpenters.org/regional-council/" target="_blank" rel="noopener">Regional Council directory</a> to locate a Regional Council in your area.'
      },
      {
        q: "I'm still having problems. How do I get help?",
        a: `If you\u2019re still having problems, please contact technical support through this <a href="${contactUrl}">contact form</a>.`
      },
      {
        q: 'How do I contact the editor?',
        a: `If you wish to contact the editor about a story, or you have a Carpenters.org story idea, go to the <a href="${contactUrl}">contact form</a>. The Carpenters Member Portal site support will respond to your query within 48 hours (Monday-Friday).`
      }
    ];
  }
}
</script>
<style scoped>
.faq-btn {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  color: #495057;
  white-space: normal;
  text-align: left;
}
.faq-answer {
  font-size: 0.9rem;
}
</style>
